function initTabs() {
    jQuery('ul.tabset').contentTabs({
        tabLinks: 'a'
    });
}
